export const CompanySubTypes = [
    'NONE',
    'LIFE',
    'HEALTH',
    'HMO',
    'PC',
    'RRG',
    'TITLE'
]